/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { Box, Divider, Typography } from '@mui/material';

export interface Props {
	title?: React.ReactNode;
	subtitle?: React.ReactNode;
	actionMenu?: JSX.Element;
}

function FormHeaderView(props: React.PropsWithChildren<Props>): JSX.Element {
	const { title, subtitle, actionMenu } = props;

	return (
		<Box
			sx={{
				marginBottom: 3
			}}
		>
			<Box
				sx={{
					paddingBottom: 0.5,
					display: 'flex'
				}}
			>
				{(title || subtitle) && (
					<Box display="flex" flexDirection="column">
						{title && <Typography variant="h1">{title}</Typography>}
						{subtitle && <Typography variant="h6">{subtitle}</Typography>}
					</Box>
				)}
				{props.children}
				{actionMenu && (
					<Box
						sx={{
							marginLeft: 'auto'
						}}
					>
						{actionMenu}
					</Box>
				)}
			</Box>
			<Divider variant="fullWidth" />
		</Box>
	);
}

export default FormHeaderView;
